export function PathLine({ from, to, color, status, isCompact }) {
  // Calculate control points for curved path
  const midX = (from.x + to.x) / 2;
  const midY = (from.y + to.y) / 2;
  
  // Add curve by offsetting the control point
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  const perpX = -dy * 0.15;
  const perpY = dx * 0.15;
  
  const controlX = midX + perpX;
  const controlY = midY + perpY;
  
  // Path styling based on status
  const getPathStyles = () => {
    switch (status) {
      case "active":
        return {
          stroke: color,
          strokeWidth: isCompact ? 1.5 : 2,
          opacity: 0.7,
          dashArray: "none"
        };
      case "explored":
        return {
          stroke: color,
          strokeWidth: isCompact ? 1 : 1.5,
          opacity: 0.5,
          dashArray: "none"
        };
      case "visited":
        return {
          stroke: color,
          strokeWidth: 1,
          opacity: 0.3,
          dashArray: "4 4"
        };
      case "neglected":
      default:
        return {
          stroke: color,
          strokeWidth: 1,
          opacity: 0.15,
          dashArray: "2 4"
        };
    }
  };

  const styles = getPathStyles();

  return (
    <g>
      {/* Glow effect for active paths */}
      {status === "active" && (
        <path
          d={`M ${from.x} ${from.y} Q ${controlX} ${controlY} ${to.x} ${to.y}`}
          fill="none"
          stroke={color}
          strokeWidth={styles.strokeWidth + 4}
          opacity={0.1}
          strokeLinecap="round"
        />
      )}
      
      {/* Main path */}
      <path
        d={`M ${from.x} ${from.y} Q ${controlX} ${controlY} ${to.x} ${to.y}`}
        fill="none"
        stroke={styles.stroke}
        strokeWidth={styles.strokeWidth}
        opacity={styles.opacity}
        strokeDasharray={styles.dashArray}
        strokeLinecap="round"
        className="transition-all duration-500"
      />
    </g>
  );
}

export default PathLine;
